import React from 'react'
import { useRef } from 'react';
import { useState } from 'react'
import FAQpic from '../images/faq.png'

const FAQ = () => {
    const myRef = useRef();

    const [selected,SetSelected] = useState(null)
    const FAQData = [
    {
        id:1,
        title:"Lorem ipsum dolor sit, amet consectetur?",
        des:"ipsum! Assumenda, dolorem nihil. Commodi, qui? Officiis provident, cumque perspiciatis magni commodi rem nihil,"
    },
    {
        id:2,
        title:"Lorem ipsum dolor sit, amet consectetur?",
        des:"ipsum! Assumenda, dolorem nihil. Commodi, qui? Officiis provident, cumque perspiciatis magni commodi rem nihil,"
    },
    {
        id:3,
        title:"Lorem ipsum dolor sit, amet consectetur?",
        des:"ipsum! Assumenda, dolorem nihil. Commodi, qui? Officiis provident, cumque perspiciatis magni commodi rem nihil,"
    },
    {
        id:4,
        title:"Lorem ipsum dolor sit, amet consectetur?",
        des:"ipsum! Assumenda, dolorem nihil. Commodi, qui? Officiis provident, cumque perspiciatis magni commodi rem nihil,"
    },
]
  return (
    <section className="py-16">
    <div className="mx-auto max-w-7xl px-8 md:px-6">
        {/* <!-- heading text --> */}
        <div className="mb-5 sm:mb-10">
            <span className="font-medium text-blue-500">Our FAQ</span>
            <h1 className="text-2xl font-bold text-slate-700 sm:text-3xl">Frequently Asked Questions</h1>
        </div>
            {/* <!-- wrapper --> */}
            <div className="md:flex md:justify-between md:gap-6">
                <div className="mb-8 flex justify-center md:mb-0 md:w-5/12">
                    <img src={FAQpic} alt="faq images" className="max-h-[500px] md:max-h-max"/>
                </div>
                
                <div className="md:w-6/12">
                    <div className="" x-data="{selected:1}">
                        <ul>
                            {FAQData && FAQData.map((data)=>(
                                <li className="relative mb-5" key={data.id}>
                                    {/* @click="selected !== 1 ? selected = 1 : selected = null" */}
                                    <button type="button" className="w-full rounded-lg bg-blue-50 px-8 py-6 text-left" onClick={()=> SetSelected(data.id)} >
                                        <div className="flex items-center justify-between">
                                            <h4 className="font-medium text-slate-600">Lorem ipsum dolor sit, amet consectetur?</h4>
                                            <ion-icon name="chevron-down-circle-outline" className="w-8 text-lg text-blue-500"></ion-icon>
                                        </div>
                                    </button>
                                    {/* x-bind:style="selected == 1 ? 'max-height: ' + $refs.container1.scrollHeight + 'px' : ''" */}
                                    <div className="relative max-h-0 overflow-hidden rounded-b-lg bg-blue-50/30 transition-all duration-500" x-ref="container1"  style={{maxHeight: selected == data.id?'100px':''} } >
                                        <div className="p-6">
                                            <p className="text-slate-500">ipsum! Assumenda, dolorem nihil. Commodi, qui? Officiis provident, cumque perspiciatis magni commodi rem nihil,</p>
                                        </div>
                                    </div>
                                </li>

                            ))}
                            
                        </ul>
                    </div>
                </div>
        </div>
    </div>
</section>

  )
}

export default FAQ